import PaymentMetadata from './PaymentMetadata';

export default PaymentMetadata;
